import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@config/server/apiClient';
import { queries } from '@config/server/queryKeys';

/**
 * Response type for completing MFA setup
 */
export interface CompleteMfaResponse {
	success: true;
	message: string;
}

/**
 * API function to complete MFA setup and advance onboarding state to COMPLETE
 */
export const completeMfa = async (): Promise<CompleteMfaResponse> => {
	const response = await apiClient.post<CompleteMfaResponse>(`/admin_portal/setup/complete-mfa`);
	return response.data;
};

/**
 * Hook for completing MFA setup (advances onboarding state to COMPLETE)
 * Invalidates /me query on success to trigger guard-based routing to home screen
 */
export const useCompleteMfa = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: completeMfa,
		onSuccess: () => {
			// Invalidate /me query to refresh user data with updated onboarding state
			// The InviteAuthGuard will automatically route based on the new onboarding state (COMPLETE)
			// which should take the user to the home screen
			queryClient.invalidateQueries({
				queryKey: queries.auth.me.queryKey,
			});
		},
	});
};
